module.exports = __webpack_public_path__ + "media/app/assets/specializations/hunter/survival-e9d81594ba2eaecf63a0203d3ebad758.png";